var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.type == "edit" ? _vm.$t("编辑") : _vm.type == "add" ? _vm.$t("新增") : _vm.$t("复制"),
      visible: _vm.dialogVisible,
      width: 1100
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      },
      rules: _vm.dataRule
    }
  }, [_c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("方案信息")))])]), _c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("方案名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("方案名称")
    },
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("方案代码"),
      prop: "code"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("方案代码")
    },
    model: {
      value: _vm.dataFrom.code,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "code", $$v);
      },
      expression: "dataFrom.code"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "price",
      label: _vm.$t("保费")
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("单位") + "：" + _vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false))
    },
    on: {
      change: function ($event) {
        return _vm.priceChange("price");
      }
    },
    model: {
      value: _vm.dataFrom.price,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "price", $$v);
      },
      expression: "dataFrom.price"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "amount",
      label: _vm.$t("保障金额")
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("单位") + "：" + _vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false))
    },
    on: {
      change: function ($event) {
        return _vm.priceChange("amount");
      }
    },
    model: {
      value: _vm.dataFrom.amount,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "amount", $$v);
      },
      expression: "dataFrom.amount"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    ref: "paymentDeadline",
    staticClass: "cont",
    attrs: {
      prop: "paymentDeadline",
      label: _vm.$t("缴费期限")
    }
  }, [_c("a-radio-group", {
    staticStyle: {
      width: "100%",
      display: "flex",
      "align-items": "center"
    },
    on: {
      change: _vm.onPaymentDeadlineChange
    },
    model: {
      value: _vm.dataFrom.paymentDeadline.way,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom.paymentDeadline, "way", $$v);
      },
      expression: "dataFrom.paymentDeadline.way"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("趸交")))]), _c("a-radio", {
    staticClass: "paymentDeadline",
    staticStyle: {
      "margin-right": "0",
      flex: "1",
      display: "flex",
      "align-items": "center"
    },
    attrs: {
      value: 1
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "80px",
      "margin-right": "20px"
    },
    attrs: {
      disabled: _vm.dataFrom.paymentDeadline.way == 1 ? false : true,
      getPopupContainer: triggerNode => triggerNode.parentNode,
      dropdownClassName: "mul-select-dropdown"
    },
    on: {
      change: function ($event) {
        _vm.dataFrom.paymentDeadline.value = undefined;
      }
    },
    model: {
      value: _vm.dataFrom.paymentDeadline.type,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom.paymentDeadline, "type", $$v);
      },
      expression: "dataFrom.paymentDeadline.type"
    }
  }, _vm._l(_vm.PAYMENDEADLINE, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1), _c("a-input-number", {
    staticStyle: {
      width: "calc(100% - 100px)"
    },
    attrs: {
      placeholder: _vm.$t("请输入"),
      disabled: _vm.dataFrom.paymentDeadline.way == 1 ? false : true,
      precision: 0,
      formatter: value => `${value}`,
      parser: value => value.replace(/[^\d]/g, "")
    },
    on: {
      blur: _vm.onPaymentDeadlineInput
    },
    model: {
      value: _vm.dataFrom.paymentDeadline.value,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom.paymentDeadline, "value", $$v);
      },
      expression: "dataFrom.paymentDeadline.value"
    }
  })], 1)], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    ref: "age",
    staticClass: "cont",
    attrs: {
      label: _vm.$t("保障年龄"),
      prop: "age"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "120px",
      "margin-right": "20px"
    },
    attrs: {
      getPopupContainer: triggerNode => triggerNode.parentNode,
      dropdownClassName: "mul-select-dropdown"
    },
    on: {
      change: function ($event) {
        ;
        _vm.age1 = "", _vm.age2 = "", _vm.onAgeInput();
      }
    },
    model: {
      value: _vm.dataFrom.age.type,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom.age, "type", $$v);
      },
      expression: "dataFrom.age.type"
    }
  }, _vm._l(_vm.AGELIST, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1), _c("div", {
    staticClass: "infoBox"
  }, [_c("a-input-number", {
    staticStyle: {
      flex: "1",
      overflow: "hidden"
    },
    attrs: {
      placeholder: _vm.$t("请输入"),
      precision: 0,
      formatter: value => `${value}`,
      parser: value => value.replace(/[^\d]/g, "")
    },
    on: {
      blur: _vm.onAgeInput
    },
    model: {
      value: _vm.age1,
      callback: function ($$v) {
        _vm.age1 = $$v;
      },
      expression: "age1"
    }
  }), _vm.dataFrom.age.type < 6 ? _c("div", {
    staticStyle: {
      width: "20px",
      height: "1px",
      background: "#d9d9d9",
      margin: "0 10px"
    }
  }) : _vm._e(), _vm.dataFrom.age.type < 6 ? _c("a-input-number", {
    staticStyle: {
      flex: "1",
      overflow: "hidden"
    },
    attrs: {
      placeholder: _vm.$t("请输入"),
      precision: 0,
      formatter: value => `${value}`,
      parser: value => value.replace(/[^\d]/g, "")
    },
    on: {
      blur: _vm.onAgeInput
    },
    model: {
      value: _vm.age2,
      callback: function ($$v) {
        _vm.age2 = $$v;
      },
      expression: "age2"
    }
  }) : _vm._e()], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("职业类别"),
      prop: "occupation"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: "1" + _vm.$t("至") + "N" + _vm.$t("类") + "，" + _vm.$t("输入格式为") + "1,n;N" + _vm.$t("类") + "，" + _vm.$t("输入格式为") + "n,n"
    },
    model: {
      value: _vm.dataFrom.occupation,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "occupation", $$v);
      },
      expression: "dataFrom.occupation"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    ref: "duration",
    staticClass: "cont",
    attrs: {
      label: _vm.$t("保障期限"),
      prop: "duration"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "120px",
      "margin-right": "20px"
    },
    attrs: {
      getPopupContainer: triggerNode => triggerNode.parentNode,
      dropdownClassName: "mul-select-dropdown"
    },
    on: {
      change: function ($event) {
        ;
        _vm.duration1 = "", _vm.duration2 = "";
      }
    },
    model: {
      value: _vm.dataFrom.duration.type,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom.duration, "type", $$v);
      },
      expression: "dataFrom.duration.type"
    }
  }, _vm._l(_vm.TERMLIST, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1), _c("div", {
    staticClass: "infoBox"
  }, [_c("a-input-number", {
    staticStyle: {
      flex: "1",
      overflow: "hidden"
    },
    attrs: {
      placeholder: _vm.$t("请输入"),
      disabled: _vm.dataFrom.duration.type == 5 ? true : false,
      precision: 0,
      formatter: value => `${value}`,
      parser: value => value.replace(/[^\d]/g, "")
    },
    on: {
      blur: _vm.onDurationInput
    },
    model: {
      value: _vm.duration1,
      callback: function ($$v) {
        _vm.duration1 = $$v;
      },
      expression: "duration1"
    }
  }), _vm.dataFrom.duration.type == 2 || _vm.dataFrom.duration.type == 4 ? _c("div", {
    staticStyle: {
      width: "20px",
      height: "1px",
      background: "#d9d9d9",
      margin: "0 10px"
    }
  }) : _vm._e(), _vm.dataFrom.duration.type == 2 || _vm.dataFrom.duration.type == 4 ? _c("a-input-number", {
    staticStyle: {
      flex: "1",
      overflow: "hidden"
    },
    attrs: {
      placeholder: _vm.$t("请输入"),
      precision: 0,
      formatter: value => `${value}`,
      parser: value => value.replace(/[^\d]/g, "")
    },
    on: {
      blur: _vm.onDurationInput
    },
    model: {
      value: _vm.duration2,
      callback: function ($$v) {
        _vm.duration2 = $$v;
      },
      expression: "duration2"
    }
  }) : _vm._e()], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("性别")
    }
  }, [_c("a-select", {
    attrs: {
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    model: {
      value: _vm.dataFrom.sex,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "sex", $$v);
      },
      expression: "dataFrom.sex"
    }
  }, _vm._l(_vm.SEXLIST, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("社保")
    }
  }, [_c("a-select", {
    attrs: {
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    model: {
      value: _vm.dataFrom.socialSecurity,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "socialSecurity", $$v);
      },
      expression: "dataFrom.socialSecurity"
    }
  }, _vm._l(_vm.SOCIALSECURITYIST, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("方案备注"),
      prop: "remark"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入")
    },
    model: {
      value: _vm.dataFrom.remark,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "remark", $$v);
      },
      expression: "dataFrom.remark"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保障单位"),
      prop: "unit"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入")
    },
    model: {
      value: _vm.dataFrom.unit,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "unit", $$v);
      },
      expression: "dataFrom.unit"
    }
  })], 1)], 1)], 1), _c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("保障权益")))])]), _c("a-form-model-item", {
    ref: "rights",
    class: _vm.rightsList.length > 1 ? "listBox" : "",
    attrs: {
      label: _vm.$t("保障权益"),
      prop: "rights",
      labelCol: {
        span: 3,
        offset: 0
      }
    }
  }, [_c("div", {
    staticClass: "list"
  }, _vm._l(_vm.rightsList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "box"
    }, [_c("div", {
      staticClass: "cont"
    }, [_c("a-input", {
      staticStyle: {
        width: "150px"
      },
      style: item.name ? "border-color: #d9d9d9" : "",
      attrs: {
        placeholder: _vm.$t("保障权益")
      },
      on: {
        blur: function ($event) {
          return _vm.$refs.rights.onFieldChange();
        }
      },
      model: {
        value: item.name,
        callback: function ($$v) {
          _vm.$set(item, "name", $$v);
        },
        expression: "item.name"
      }
    }), _c("a-input", {
      staticStyle: {
        "margin-left": "20px",
        width: "100px"
      },
      style: item.value ? "border-color: #d9d9d9" : "",
      attrs: {
        placeholder: _vm.$t("保障金额")
      },
      on: {
        blur: function ($event) {
          return _vm.$refs.rights.onFieldChange();
        }
      },
      model: {
        value: item.value,
        callback: function ($$v) {
          _vm.$set(item, "value", $$v);
        },
        expression: "item.value"
      }
    }), _c("a-input", {
      staticStyle: {
        "margin-left": "20px",
        "border-color": "#d9d9d9"
      },
      attrs: {
        placeholder: _vm.$t("权益说明(选填)")
      },
      on: {
        blur: function ($event) {
          return _vm.$refs.rights.onFieldChange();
        }
      },
      model: {
        value: item.info,
        callback: function ($$v) {
          _vm.$set(item, "info", $$v);
        },
        expression: "item.info"
      }
    })], 1), _c("div", {
      staticClass: "right"
    }, [index == 0 ? _c("a-button", {
      attrs: {
        type: "add"
      },
      on: {
        click: _vm.addRightsFun
      }
    }, [_vm._v(_vm._s(_vm.$t("添加")))]) : _c("a-button", {
      attrs: {
        type: "danger"
      },
      on: {
        click: function ($event) {
          return _vm.delRightsFun(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("删除")))])], 1)]);
  }), 0)]), _vm.termsShow ? _c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("方案条款")))])]) : _vm._e(), _vm.termsShow ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("条款文件"),
      labelCol: {
        span: 3,
        offset: 0
      },
      prop: "insuranceTermsId"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择"),
      "filter-option": _vm.dropDownSearchNo,
      "show-search": "",
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: _vm.termsChange
    },
    model: {
      value: _vm.termsId,
      callback: function ($$v) {
        _vm.termsId = $$v;
      },
      expression: "termsId"
    }
  }, _vm._l(_vm.termsList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _vm.tagList.length != 0 ? _c("div", _vm._l(_vm.tagList, function (tag) {
    return _c("a-tag", {
      key: tag.id,
      staticStyle: {
        "white-space": "initial"
      },
      attrs: {
        color: "blue",
        closable: true
      },
      on: {
        close: () => _vm.handleTagClose(tag)
      }
    }, [_vm._v(_vm._s(tag.name))]);
  }), 1) : _vm._e()], 1) : _vm._e()], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    staticStyle: {
      width: "100px"
    },
    attrs: {
      type: "primary",
      size: "small",
      loading: _vm.saveLoading,
      disabled: _vm.saveLoading
    },
    on: {
      click: _vm.handleSure
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保存")) + " ")]), _vm.type == "add" ? _c("a-checkbox", {
    staticClass: "marginL15",
    attrs: {
      checked: _vm.continueState
    },
    on: {
      change: _vm.onContinueToAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("继续添加")) + " ")]) : _vm._e()], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };